import React from "react";

import LoginLayout from "../../components/universal/login-layout";
import LoginPageContent from "../../components/public/login";
import { Helmet } from "react-helmet-async";

const LoginPage = () => {
  return (
    <>
      <Helmet>
        <title>Leadfind - Logg inn på dashboardet</title>
        <meta name="thumbnail" content="https://leadfind.no/showcase.jpg" />
        <meta name="robots" content="index, follow" />
        <meta
          name="description"
          content="Logg inn med din Leadfind-konto for å få tilgang til dashboard og oversikt over alle kunder, prestasjoner, lister og andre KPI-er for bedriften din."
        />
        <meta name="author" content="Leadfind" />
        <meta
          name="keywords"
          content="prospecting, salgsverktøy, salg, nye kunder, crm"
        />

        <meta name="twitter:card" content="summary" />
        <meta name="twitter:url" content="https://leadfind.no/logg-inn" />
        <meta name="twitter:title" content="Leadfind - Salgsverktøy og CRM" />
        <meta
          name="twitter:description"
          content="Logg inn med din Leadfind-konto for å få tilgang til dashboard og oversikt over alle kunder, prestasjoner, lister og andre KPI-er for bedriften din."
        />
        <meta name="twitter:image" content="https://leadfind.no/showcase.jpg" />

        <meta property="og:url" content="https://leadfind.no/logg-inn" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Leadfind - Salgsverktøy og CRM" />
        <meta
          property="og:description"
          content="Logg inn med din Leadfind-konto for å få tilgang til dashboard og oversikt over alle kunder, prestasjoner, lister og andre KPI-er for bedriften din."
        />
        <meta property="og:image" content="https://leadfind.no/showcase.jpg" />
        <link rel="canonical" href="https://leadfind.no/logg-inn" />
      </Helmet>
      <LoginLayout Content={() => <LoginPageContent />} />
    </>
  );
};

export default LoginPage;
